import { RESET_STATE } from 'JS/actionCreators/generalActions';
import {
  SET_USER_SETTING,
  LOAD_USER_SETTINGS_SUCCESS,
  LOAD_USER_SETTINGS_FAILED
} from 'JS/actionCreators/userSettingsActions';

const initialState = {
  loadingUserSettings: true,
  settings: { recordWithPlayback: true }
};

export default function userSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_USER_SETTINGS_FAILED: {
      return {
        ...state,
        loadingUserSettings: false
      };
    }

    case LOAD_USER_SETTINGS_SUCCESS: {
      return {
        ...state,
        loadingUserSettings: false,
        settings: {
          ...state.settings,
          ...action.settings
        }
      };
    }

    case SET_USER_SETTING: {
      return {
        ...state,
        settings: {
          ...state.settings,
          [action.setting]: action.value
        }
      };
    }

    case RESET_STATE: {
      return initialState;
    }

    default:
      return state;
  }
}
